import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import contractExtension, { ContractExtensionState } from './contract-extensions/contract-extension.store';
import { EmployeeService } from './employees.service';
import performanceOverview, { PerformanceOverviewState } from './performances-overview/performance-overview.store';

const service = new EmployeeService();

export interface EmployeeState {
   //sub-modules
   contractExtension?: ContractExtensionState;
   performanceOverview?: PerformanceOverviewState;
}

const EmployeeStore: Module<EmployeeState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getEmployees(context, payload: { customerId: number; query?: LocationQuery }) {
         return await service.getEmployees(payload.customerId, payload.query);
      },
   },
   modules: {
      contractExtension,
      performanceOverview,
   },
};

export default EmployeeStore;
